import * as React from 'react';
import { observer } from 'mobx-react';
import autobind from "autobind-decorator";
import { Button, Tabs, Breadcrumb, Icon, Col, Row } from 'antd';

import { DropdownView } from 'src/core/ui/dropdown.view';
import { resolve } from 'inversify-react';
import { RulesReflectionService } from 'src/app/rules/rules/rules.reflection.service';
import { TextView } from 'src/core/ui/text.view';
import { BooleanView } from 'src/core/ui/boolean.view';
import { UserEditorController } from 'src/app/general/users/parts/user-editor.controller';
import { DateView } from 'src/core/ui/date.view';


interface QuoteEntryModifyConditionProps {
	onFieldChange: (field: string, value: any) => void;
	values?: { [id: string]: any };
	mode: ControlMode;
}

@observer
export class QuoteEntryModifyCondition extends React.Component<QuoteEntryModifyConditionProps, any> {
	constructor(props) {
		super(props);

	}

	render() {

		const { values } = this.props;
		
		return (
			<React.Fragment>
				<div>

					<p style={{ margin: '7px' }}
					>Return true if checkin or checkout dates change</p>

					
				</div>



			</React.Fragment>);
	}
}



// WEBPACK FOOTER //
// ./src/app/rules/rules/form/parts/conditions/quote-entry-modify.condition.tsx